<div class="d-flex flex-row justify-content-start align-items-center py-1 mb-1 border-bottom flag-box">
  <div style="flex: 1" class="d-flex flex-row justify-content-start align-items-center text-truncate">
    <img [src]="info?.details?.Country | getFlag" alt="{{ info?.details?.Country }}" class="flag mr-1"
      onerror="this.src=''" />
    <span class="text-truncate" [textContent]="info?.details?.Track"></span>
    &nbsp;-&nbsp;<span>{{ "RACES.R" | translate }}{{ info?.details?.Number }}</span>
  </div>
  <span>{{ raceDate | date: "HH:mm" }}</span>
</div>

<ng-container *ngIf="allInfo$ | async as allInfo">
  <ng-container *ngIf="allInfo.length > 0">
    <ng-container *ngFor="let infoSelected of allInfo ;let i = index;">
      <div class="d-flex flex-column justify-content-start align-items-stretch pb-2 border-bottom">
        <div class="d-flex flex-row justify-content-between align-items-center text-uppercase mt-2">
          <span>
            {{ infoSelected?.selectedBet?.name | bettingType | translate | capitalizeFirst }}
          </span>
          <!-- ({{info.selectedBetType}})  -->
          <span class="cancel-slip-icon text-danger" (click)="removeBetsOnCart(i,infoSelected?.totalPrice)">
            <i class="fa fa-times"></i>
          </span>
        </div>
        <div *ngFor="let raceSelected of infoSelected?.selectedRunnersObjIterable"
          class="d-flex flex-row justify-content-between align-items-start mt-1">
          <div style="white-space: nowrap; display: flex">
            <div class="font-weight-bold bet-rank-icon text-center border">
              {{ raceSelected[0] | betRank2: infoSelected?.selectedBet?.type:info?.selectedRunners }}
            </div>
            :
          </div>
          <span class="text-right" [sortablejs]="raceSelected[1]" [sortablejsOptions]="options">
            <span *ngFor="let itemSelected of raceSelected[1];let isLast = last" class="race-number">
              {{itemSelected.runnerProgramNumber}}
            </span>
          </span>
        </div>
      </div>

    </ng-container>
  </ng-container>
</ng-container>

<div class="d-flex flex-column justify-content-start align-items-stretch pb-2 border-bottom"
  *ngIf="this.betService.showCurrentBet$ | async">
  <div class="d-flex flex-row justify-content-between align-items-center text-uppercase mt-2">
    <span>
      {{ info?.selectedBet?.name | bettingType | translate | capitalizeFirst }}
    </span>
    <!-- ({{info.selectedBetType}})  -->
    <span class="cancel-slip-icon text-danger" (click)="clearBetSlip()">
      <i class="fa fa-times"></i>
    </span>
  </div>
  <div *ngFor="let race of info?.selectedRunnersObjIterable"
    class="d-flex flex-row justify-content-between align-items-start mt-1">
    <div style="white-space: nowrap; display: flex">
      <div class="font-weight-bold bet-rank-icon text-center border">
        {{ race[0] | betRank2: info?.selectedBet?.type:info?.selectedRunners }}
      </div>
      :
    </div>
    <span class="text-right" [sortablejs]="race[1]" [sortablejsOptions]="options">
      <span *ngFor="let item of race[1];let isLast = last" class="race-number">
        {{item.runnerProgramNumber}}
      </span>
    </span>
  </div>
</div>

<ng-container *ngIf="betService.allAddedBetsInCart$.value.length < 4">
  <div class="d-flex flex-row justify-content-between mt-2">
    <span></span>
    <button class="btn btn-sm" style="padding: 0 !important;" (click)="addNewBet()">
      <i class="fa fa-plus cancel-slip-icon text-success"></i>
    </button>
  </div>
</ng-container>